<template>
  <!-- <b-navbar toggleable="md" fixed="top" type="dark" variant="dark"> -->
  <b-container class="navbar-light-background" fluid >
    <b-container id="pad" fluid style="padding: 50px 140px 50px 140px">
       <b-navbar toggleable="lg">
      
        
        <!-- <b-navbar-brand :to="{name: 'home'}" ><img src="@/assets/images/logos/VectorByte-logo-4k.png" width="25%"  /></b-navbar-brand> -->
      <b-navbar-brand :to="{name: 'home'}" ><b-img id="brand-img" class="brand-img" src="@/assets/images/logos/VectorByte-logo-4k.png" fluid></b-img></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" class="ml-auto"></b-navbar-toggle>
      
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="nav-items ml-auto" style="line-height: 20px; font-weight: 300; color:black">
            
            <b-nav-item href="https://www.vectorbyte.org/">Home</b-nav-item>
            <b-nav-item href="https://www.vectorbyte.org/our-team">Our Team</b-nav-item>
            <b-nav-item href="https://www.vectorbyte.org/faqs">FAQs</b-nav-item>
            <b-nav-item href="https://www.vectorbyte.org/blog">Blog</b-nav-item>
            <b-nav-item-dropdown text="Databases" class="nav" toggle-class="drop-down-toggle" left :no-caret="false">
              <b-dropdown-item :to="{name: 'vecdyn-datasets'}">VecDyn</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item :to="{name: 'vectraits-explorer'}">VecTraits</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item href="https://www.vectorbyte.org/vecdataecosystem">VectorData Ecosystem</b-dropdown-item>
            </b-nav-item-dropdown>
            <!-- <b-nav-item :to="{name: 'legacy-databases'}" class="nav">
              <RouteCheck routeName="legacy-databases" />
            </b-nav-item> -->
            <b-nav-item href="https://www.twitter.com/Vector_Byte">
              <i class="fab fa-twitter"></i>
            </b-nav-item>
            <b-nav-item>
              <i class="fab fa-facebook-f"></i>
            </b-nav-item>
            
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

    </b-container>   
  </b-container>
</template>

<script>
import { mapState } from "vuex";
// import RouteCheck from "@/components/frontend/RouteCheck.vue";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["user"])
  },
  methods: {
    toggle: function() {
      this.drawer = !this.drawer;
    }
  },
  components:{
    // RouteCheck
  }
};
</script>

<style>
  #brand-img{
    max-height: 30px;
  }

  @media (min-width: 800px){ #brand-img {max-height: 110px} }

  .navbar-light-background {
    background-color: #fcf6eb !important;
    font-family: Poppins;
  }

  .nav{
    color: black;
    font-weight: bold;
    white-space: nowrap;
  }
</style>